import { defineStore } from 'pinia'

import { useDefaultStore } from '@/store/defaultStore'

import { getScriptNodeParameters, sendTestScriptRequest } from '@/api/call-flows-routes'

import { parseParams } from '@/helpers/destinations/destination-request-helper'

export const useDetailCallFlowScriptNodeStore = defineStore('useDetailCallFlowScriptNode', {
    state: () => ({
        params: [],
        items: [],
    }),
    actions: {
        async goToLoadParamsThree(slug) {
            const defaultStore = useDefaultStore()

            const { success, payload, message } = await getScriptNodeParameters(slug)

            if (success) {
                this.params = payload
                this.items = parseParams(payload)
            } else {
                defaultStore.setErrorMessage({ message })
            }
        },

        async goToSendTestScriptRequest(formData) {
            const defaultStore = useDefaultStore()

            const { success, payload, message } = await sendTestScriptRequest(formData)

            if (!success) {
                defaultStore.setErrorMessage({ message })
            }

            return { success, payload }
        },

        addOrUpdateCallerInput(block) {
            const { slug, config } = block

            const findIndex = this.params['Call Flow Parameters'].findIndex((item) => item.slug === slug)

            if (findIndex !== -1) {
                this.params['Call Flow Parameters'][findIndex] = { ...this.params['Call Flow Parameters'][findIndex], key: config.parameter_name, id: slug }
            } else {
                this.params['Call Flow Parameters'] = [...this.params['Call Flow Parameters'], { key: config.parameter_name, slug, id: slug }]
            }

            this.items = parseParams(this.params)
        },

        deleteFilterBySlug(slug) {
            this.params['Call Flow Parameters'] = this.params['Call Flow Parameters'].filter((item) => item.id !== slug || item.slug !== slug)

            this.items = parseParams(this.params)
        },
    },
})
